import React from "react";
import { Location } from "../Location";
import CustomerProfile from "../../customers/CustomerProfile/CustomerProfile";

interface Params {
  customerId: string;
  groupId?: string;
}

export class CustomerProfileLocation extends Location<Params> {
  constructor(customerId: string, groupId?: string) {
    super({ customerId, groupId });
  }

  render() {
    return (
      <CustomerProfile
        id={this.params.customerId}
        directUri={this.toURI()}
        customerGroup={this.params.groupId}
      />
    );
  }

  toURI() {
    const { customerId, groupId } = this.params;
    return `/customers/${customerId}` + (groupId ? `/group/${groupId}` : "");
  }
}
